import {Action} from '@ngrx/store';

export const GET_ALL_SHIFTS = '[SHIFT] GET_ALL';
export const GET_ALL_SHIFTS_SUCCESS = '[SHIFT] GET_ALL_SUCCESS';
export const GET_ALL_SHIFTS_FAIL = '[SHIFT] GET_ALL_FAIL';

export const CREATE_SHIFT = '[SHIFT] CREATE';
export const CREATE_SHIFT_SUCCESS = '[SHIFT] CREATE_SUCCESS';
export const CREATE_SHIFT_FAIL = '[SHIFT] CREATE_FAIL';

export const GET_SHIFT_DETAILS = '[SHIFT] GET SHIFT DETAILS';
export const GET_SHIFT_DETAILS_SUCCESS = '[SHIFT] GET SHIFT DETAILS SUCCESS';
export const GET_SHIFT_DETAILS_ERROR = '[SHIFT] GET SHIFT DETAILS ERROR';

export const DELETE_SHIFT = '[SHIFT] DELETE';
export const DELETE_SHIFT_SUCCESS = '[SHIFT] DELETE_SUCCESS';
export const DELETE_SHIFT_FAIL = '[SHIFT] DELETE_FAIL';


export class GetAllShifts implements Action {
  readonly type = GET_ALL_SHIFTS;

  constructor(public payload: any) {
  }
}

export class GetAllShiftsSuccess implements Action {
  readonly type = GET_ALL_SHIFTS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllShiftsFail implements Action {
  readonly type = GET_ALL_SHIFTS_FAIL;

  constructor(public payload: any) {
  }
}

export class GetShiftDetails implements Action {
  readonly type = GET_SHIFT_DETAILS;

  constructor(public payload: any) {
  }
}

export class GetShiftDetailsSuccess implements Action {
  readonly type = GET_SHIFT_DETAILS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetShiftDetailsError implements Action {
  readonly type = GET_SHIFT_DETAILS_ERROR;

  constructor(public payload: any) {
  }
}

export class CreateShift implements Action {
  readonly type = CREATE_SHIFT;

  constructor(public payload: any) {
  }
}

export class CreateShiftSuccess implements Action {
  readonly type = CREATE_SHIFT_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CreateShiftFail implements Action {
  readonly type = CREATE_SHIFT_FAIL;

  constructor(public payload: any) {
  }
}

export class DeleteShift implements Action {
  readonly type = DELETE_SHIFT;

  constructor(public payload: any) {
  }
}

export class DeleteShiftSuccess implements Action {
  readonly type = DELETE_SHIFT_SUCCESS;

  constructor(public payload: any) {
  }
}

export class DeleteShiftFail implements Action {
  readonly type = DELETE_SHIFT_FAIL;

  constructor(public payload: any) {
  }
}


export type ShiftAction = GetAllShifts
  | GetAllShiftsSuccess
  | GetAllShiftsFail
  | GetShiftDetails
  | GetShiftDetailsSuccess
  | GetShiftDetailsError
  | CreateShift
  | CreateShiftSuccess
  | CreateShiftFail
  | DeleteShift
  | DeleteShiftSuccess
  | DeleteShiftFail;



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/actions/shift.action.ts